// Local storage keys
export const CUSTOMER_WIDGET_TOKEN_KEY = "redo.customer_widget_auth_token";
export const CONCIERGE_PROMPT_KEY = "redo.assistant_prompt";
export const CONCIERGE_INITIAL_MESSAGES_KEY = "redo.initial_concierge_messages";
export const CONCIERGE_PREFILL_TEXT_KEY = "redo.concierge_prefill_text";
export const CONCIERGE_TREATMENT_KEY = "redo.concierge_treatment";
export const EXPANDED_WARRANTY_TREATMENT_KEY =
  "redo.expanded_warranty_treatment";
export const ANONYMOUS_SHOPPER_ID_KEY = "redo.anonymous_shopper_id";
export const ANONYMOUS_SHOPIFY_SESSION_ID_KEY =
  "redo.anonymous_shopify_session_id";
export const CUSTOMER_EMAIL = "redo.customer_email";
export const CUSTOMER_PHONE = "redo.customer_phone";
export const CONCIERGE_CONVERSATION_LOCAL_STORAGE_KEY =
  "redo.concierge-conversation-id";
export const CONCIERGE_PDP_SOURCE_KEY = "redo.concierge_pdp_source";
export const CHECKOUT_OPTIMIZATION_TREATMENT_KEY = "rco_treatment";

// DOM elements
export const CUSTOMER_WIDGET_ELEMENT_ID = "redo-chat-widget";
export const CUSTOMER_WIDGET_CONTAINER_ID = "redo-chat-widget-container";

// Window events
export const OPEN_CUSTOMER_WIDGET_EVENT_KEY = "redo.open_customer_widget";
export const REDO_USER_LOGGED_IN_EVENT_KEY = "redo_user_logged_in";
export const CONCIERGE_APP_BLOCK_MESSAGE_EVENT_KEY =
  "concierge_app_block_message";
export const CONCIERGE_SET_INPUT_TEXT_EVENT_KEY = "redo.set_concierge_input";

interface ConciergePromptEventDetail {
  prompt: string;
}

export class ConciergePromptEvent extends CustomEvent<ConciergePromptEventDetail> {
  constructor(prompt: string) {
    super(CONCIERGE_APP_BLOCK_MESSAGE_EVENT_KEY, { detail: { prompt } });
  }
}

interface ConciergeSetInputTextEventDetail {
  text: string;
}

export class ConciergeSetInputTextEvent extends CustomEvent<ConciergeSetInputTextEventDetail> {
  constructor(text: string) {
    super(CONCIERGE_SET_INPUT_TEXT_EVENT_KEY, { detail: { text } });
  }
}

// URL constants
export const REDO_CONCIERGE_HASH = "#redo-concierge";
// TODO: Change to a Record<TreatmentType, string>
export const COVERAGE_TREATMENT_ID_QUERY_PARAM = "treatment_id";
export const CONCIERGE_TREATMENT_ID_QUERY_PARAM = "concierge_treatment_id";
export const EXPANDED_WARRANTY_TREATMENT_ID_QUERY_PARAM = "ew_treatment_id";
// Cart attribute keys
export const SESSION_IDS_CART_ATTRIBUTE_KEY = "redo.sessionIds";
export const CONCIERGE_ATTRIBUTION_CART_ATTRIBUTE_KEY =
  "redo.conciergeAssisted";
export const ANONYMOUS_ID_CART_ATTRIBUTE_KEY = "customer_event_id";
export const ANONYMOUS_SHOPIFY_SESSION_ID_CART_ATTRIBUTE_KEY =
  "checkout_session_id";
